import { render } from "./KplIndexPage.vue?vue&type=template&id=24dbe20c&scoped=true"
import script from "./KplIndexPage.vue?vue&type=script&lang=js"
export * from "./KplIndexPage.vue?vue&type=script&lang=js"

import "./KplIndexPage.vue?vue&type=style&index=0&id=24dbe20c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24dbe20c"]])

export default __exports__